(function () {
    'use strict';

    angular.module('swif.achats')
    .directive('swifInputProductDqe', swifInputProductDqe)
    .directive('panelPurchase', panelPurchase)
    .directive('panelQuotation', panelQuotation)
    .factory('consumableStockMoveService', consumableStockMoveService)
    .directive('consumableStockMoves', consumableStockMoves);

    function panelPurchase (swif) {
        'ngInject';
        var directive = swif.panel.create_directive('purchase_order');
        directive.templateUrl = 'partials/achats/panel_purchase.html';
        return directive;
    }

    function panelQuotation (swif) {
        'ngInject';
        var directive = swif.panel.create_directive('purchase_order');
        directive.templateUrl = 'partials/achats/panel_quotation.html';
        return directive;
    }

    // product = product_id [ID, NAME] in readonly
    // ng-model = name (based on product[1])
    // has swif-change, ...

    function swifInputProductDqe (swif) {
        'ngInject';
        var d = angular.copy(swif.form.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.product = '=';
        delete d.transclude;
        d.templateUrl = 'partials/achats/swif_input_product_dqe.html';
        d.link = swif.form.falseProxyLink;
        return d;
    }

    function consumableStockMoveService (swif) {
        var service = {};
        service.COLLECTION_ID = 'consumable_stock_moves';
        service.COLLECTION_FIELDS = [
            'name', 'service_id', 'claimer_id', 'move_type', 'warehouse_id',
            'date', 'product_qty', 'origin', 'purchase_line_id', 'price_unit', 'default_price', 'pump', 'stock_value'
        ];
        service.getCollection = function (collId) {
            return swif.collection.getCollection(collId || service.COLLECTION_ID);
        };

        service.createCollection = function (collId, productId) {
            var filter = {};
            filter.fields = service.COLLECTION_FIELDS;
            swif.data.sortOn(filter, 'date', 'DESC');
            swif.data.setLimit(filter, 10);
            swif.data.addExtraFilter(filter, 'moveByProd', 'product_id', '=', productId || 0);
            swif.data.addExtraFilter(filter, 'moveByProd', 'state', '=', 'done');
            return swif.collections.createOrUpdate(
                collId || service.COLLECTION_ID,
                'stock_move',
                filter,
                {location: true}
            );
        };
        return service;
    }

    consumableStockMoves.$inject = ['consumableStockMoveService', 'gettextCatalog'];
    function consumableStockMoves (service, gettextCatalog) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                collectionId: '@?'
            },
            link: function (scope, element, attr, ngModel) {
                function initialize () {
                    scope.collection = {};

                    scope.translate = {
                        'in': gettextCatalog.getString('In', null, "Stock input"),
                        'out': gettextCatalog.getString('Out', null, "Stock output"),
                        'notAssociated': gettextCatalog.getString('Not associated')
                    };

                    scope.preModal = service.preModal;
                    scope.preValidate = service.preValidate;
                    scope.callback = service.callback;
                    ngModel.$render = function () {
                        var prodId = ngModel.$viewValue;
                        service.createCollection(scope.collectionId, prodId)
                        .then(function (coll) {
                            scope.collection = coll;
                        });
                    };
                }
                initialize();
            },
            templateUrl: 'partials/achats/consumable_stock_move_table_directive.html'
        };
    }
})();
